enum AgeType {
    YEARS = 'YEARS',
    MONTHS = 'MONTHS'
}

export default AgeType;
